import EMPTY_FILTRO from './emptyFiltro'

const EMPTY_FILTRO_CADASTRO = (caixa) => {
  return {
    ...EMPTY_FILTRO(caixa),
    municipios: []
  }
}

export default EMPTY_FILTRO_CADASTRO



// WEBPACK FOOTER //
// ./src/libs/models/filtro/emptyFiltroCadastroCentral.js